import MobileDetect from 'mobile-detect';

export const mobileDetect = new MobileDetect(window.navigator.userAgent);
const mobileUserAgent = !!mobileDetect.mobile();

export function isMobileUserAgent() {
  return mobileUserAgent;
}
